import React from 'react';
import { toast } from 'sonner';
import { adminApi } from '../../lib/adminAuth';
import DeliveryReport from './DeliveryReport';

const STATUS = { sent: 'bg-emerald-100 text-emerald-700', scheduled: 'bg-sky-100 text-sky-700', sending: 'bg-amber-100 text-amber-800', cancelled: 'bg-slate-200 text-slate-600' };
const fmt = (v) => (v ? new Date(v).toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : '');
const who = (c) => (c.audience === 'all' ? 'Everyone' : c.audience === 'users' ? `${c.recipient_count} people` : c.roles.join(', '));

export default function PushHistory({ items, onChange }) {
  const [report, setReport] = React.useState(null);
  const cancel = async (id) => {
    try { await adminApi.delete(`/api/admin/push/campaigns/${id}`); toast.success('Cancelled'); onChange(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Could not cancel'); }
  };
  return (
    <div className="soft-card p-5" data-testid="push-history">
      <h2 className="font-semibold text-[#1a1a2e] mb-3">Sent & scheduled</h2>
      {!items.length && <p className="text-sm text-slate-400" data-testid="push-history-empty">Nothing sent yet.</p>}
      <div className="space-y-2">
        {items.map((c) => (
          <div key={c.id} className="p-3 rounded-xl border border-slate-200 bg-white" data-testid={`push-campaign-${c.id}`}>
            <div className="flex items-start gap-2">
              <div className="flex-1 min-w-0">
                <p className="font-medium text-sm text-slate-900 truncate">{c.title}</p>
                <p className="text-xs text-slate-500 line-clamp-2">{c.body}</p>
              </div>
              <span className={`px-2 py-0.5 rounded-full text-[11px] font-semibold capitalize ${STATUS[c.status]}`} data-testid={`push-campaign-status-${c.id}`}>{c.status}</span>
            </div>
            <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] text-slate-500">
              <span>To: {who(c)}</span>
              {c.source === 'festival' && <span className="px-1.5 rounded bg-amber-100 text-amber-800 font-semibold" data-testid={`push-campaign-festival-${c.id}`}>Auto · {c.festival}</span>}
              {c.important && <span className="px-1.5 rounded bg-rose-100 text-rose-700 font-semibold" data-testid={`push-campaign-important-${c.id}`}>Important</span>}
              {c.status === 'scheduled' && <span>At {fmt(c.scheduled_at)}</span>}
              {c.status === 'sent' && <span data-testid={`push-campaign-result-${c.id}`}>{fmt(c.sent_at)} · {c.sent}/{c.devices} phones{c.failed ? ` · ${c.failed} failed` : ''} · {c.delivered} delivered · {c.opened} opened</span>}
              {c.status === 'sent' && <button type="button" onClick={() => setReport(c)} className="ml-auto text-[#1a1a2e] font-semibold hover:underline" data-testid={`push-campaign-report-${c.id}`}>Report</button>}
              {c.status === 'scheduled' && <button type="button" onClick={() => cancel(c.id)} className="ml-auto text-rose-600 font-semibold hover:underline" data-testid={`push-campaign-cancel-${c.id}`}>Cancel</button>}
            </div>
          </div>
        ))}
      </div>
      <DeliveryReport campaign={report} onClose={() => setReport(null)} />
    </div>
  );
}
